/**
 * Search Conditions Module - Phase 3 Migration (Orchestrator)
 * Re-exports all search condition functions for backward compatibility
 */

"use strict";

// Import from refactored modules
import { getMatchConditions, escapeForCategory, arabicToRoman, isStandaloneNumber } from './query-parser/query-parser.js';
import { myEach } from './file-matcher/file-matcher.js';
import { highlightText } from './text-highlighter.js';
import { addCategoryMatchConditions } from './category-matcher.js';

// Re-export all functions for backward compatibility
export { getMatchConditions, myEach, addCategoryMatchConditions, highlightText };

// Global exports for backward compatibility
window.getMatchConditions = getMatchConditions;
window.myEach = myEach;
window.addCategoryMatchConditions = addCategoryMatchConditions;
window.highlightText = highlightText;
